import messages from "./messages";

export const DEFAULT_LOCALE = "en";
export const SUPPORTED_LOCALES = ["en", "ru"];

export const normalizeLocale = (locale = "") => {
  const normalized = locale.toString().toLowerCase();
  if (normalized.startsWith("ru")) return "ru";
  return DEFAULT_LOCALE;
};

export const getInitialLocale = () => {
  if (typeof localStorage !== "undefined" && localStorage.getItem("locale")) {
    return normalizeLocale(localStorage.getItem("locale"));
  }
  if (typeof navigator !== "undefined") {
    return normalizeLocale(navigator.userLanguage || navigator.language);
  }
  return DEFAULT_LOCALE;
};

const getMessage = (locale, key) =>
  key.split(".").reduce((value, part) => {
    if (value && Object.prototype.hasOwnProperty.call(value, part)) {
      return value[part];
    }
    return undefined;
  }, messages[locale]);

const interpolate = (message, params = {}) =>
  message.replace(/\{(\w+)\}/g, (match, key) =>
    params[key] === undefined || params[key] === null ? match : params[key],
  );

export const t = (locale, key, params) => {
  const normalizedLocale = normalizeLocale(locale);
  const message =
    getMessage(normalizedLocale, key) || getMessage(DEFAULT_LOCALE, key);
  if (message === undefined) return key;
  if (Array.isArray(message)) {
    return interpolate(message[0], params);
  }
  return interpolate(message, params);
};

const getPluralIndex = (locale, count) => {
  if (locale !== "ru") return count === 1 ? 0 : 1;
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return 0;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1;
  return 2;
};

export const tp = (locale, key, count, params = {}) => {
  const normalizedLocale = normalizeLocale(locale);
  const message =
    getMessage(normalizedLocale, key) || getMessage(DEFAULT_LOCALE, key);
  if (!Array.isArray(message)) return t(normalizedLocale, key, params);
  const pluralIndex = getPluralIndex(normalizedLocale, count);
  return interpolate(message[pluralIndex] || message[message.length - 1], {
    count,
    ...params,
  });
};

export const teamName = (locale, team) => t(locale, `teams.${team}`);

export const install = (Vue) => {
  Vue.prototype.$t = function (key, params) {
    const locale =
      this.$store && this.$store.state
        ? this.$store.state.locale
        : getInitialLocale();
    return t(locale, key, params);
  };

  Vue.prototype.$tp = function (key, count, params) {
    const locale =
      this.$store && this.$store.state
        ? this.$store.state.locale
        : getInitialLocale();
    return tp(locale, key, count, params);
  };

  Vue.prototype.$team = function (team) {
    const locale =
      this.$store && this.$store.state
        ? this.$store.state.locale
        : getInitialLocale();
    return teamName(locale, team);
  };
};

export default { install };
